var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 103,
    viewBox: "0 0 111 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.2915 28.0619C91.4169 28.0619 106 44.4809 106 62.7011C106 68.5205 104.303 74.513 101.324 79.986C100.769 80.8867 100.7 82.0297 101.081 83.1036L103.402 90.8627C103.922 92.7332 102.328 94.1188 100.562 93.5646L93.5645 91.4862C91.6594 90.8627 90.1699 91.6594 88.3998 92.7333C83.3425 95.7122 77.0416 97.2363 71.3608 97.2363C54.1798 97.2363 36.7216 83.9695 36.7216 62.5972C36.7216 44.1691 51.6165 28.0619 71.2915 28.0619Z",
    fill: "url(#paint0_linear_1_53)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.4102 63.0463C93.4102 75.4041 83.3947 85.4174 71.0391 85.4174C58.6836 85.4174 48.668 75.4041 48.668 63.0463C48.668 50.693 58.6836 40.6752 71.0391 40.6752C83.3947 40.6752 93.4102 50.693 93.4102 63.0463Z",
    fill: "#3685FB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1_53)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_1_53",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 91,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 91,
    height: 91
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2894 1C19.6086 1 1 21.9513 1 45.201C1 52.6268 3.16585 60.2735 6.96714 67.2573C7.67435 68.4065 7.76275 69.8652 7.27654 71.2354L4.31508 81.1364C3.65206 83.5233 5.68531 85.2913 7.93956 84.5841L16.8682 81.932C19.2992 81.1364 21.1999 82.153 23.4585 83.5233C29.9119 87.3246 37.952 89.2694 45.201 89.2694C67.1247 89.2694 89.402 72.3404 89.402 45.0684C89.402 21.5535 70.3956 1 45.2894 1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.2894 1C19.6086 1 1 21.9513 1 45.201C1 52.6268 3.16585 60.2735 6.96714 67.2573C7.67435 68.4065 7.76275 69.8652 7.27654 71.2354L4.31508 81.1364C3.65206 83.5233 5.68531 85.2913 7.93956 84.5841L16.8682 81.932C19.2992 81.1364 21.1999 82.153 23.4585 83.5233C29.9119 87.3246 37.952 89.2694 45.201 89.2694C67.1247 89.2694 89.402 72.3404 89.402 45.0684C89.402 21.5535 70.3956 1 45.2894 1Z",
    fill: "#3685FB",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2894 2C45.8417 2 46.2894 1.55228 46.2894 1C46.2894 0.447715 45.8417 0 45.2894 0V2ZM6.96714 67.2573L6.08882 67.7354C6.09729 67.7509 6.10618 67.7663 6.11548 67.7814L6.96714 67.2573ZM7.27654 71.2354L6.33411 70.901C6.3285 70.9168 6.32329 70.9328 6.31848 70.9488L7.27654 71.2354ZM4.31508 81.1364L3.35701 80.8499C3.35513 80.8561 3.35331 80.8624 3.35156 80.8688L4.31508 81.1364ZM7.93956 84.5841L7.65482 83.6255C7.64994 83.6269 7.64507 83.6284 7.64022 83.63L7.93956 84.5841ZM16.8682 81.932L17.1529 82.8906C17.1617 82.888 17.1705 82.8853 17.1792 82.8824L16.8682 81.932ZM23.4585 83.5233L22.9398 84.3783L22.951 84.3849L23.4585 83.5233ZM45.2894 0C44.7371 0 44.2894 0.447715 44.2894 1C44.2894 1.55228 44.7371 2 45.2894 2V0ZM45.2894 0C19.0234 0 0 21.4325 0 45.201H2C2 22.4701 20.1938 2 45.2894 2V0ZM0 45.201C0 52.8177 2.21996 60.6275 6.08882 67.7354L7.84546 66.7792C4.11174 59.9196 2 52.4358 2 45.201H0ZM6.11548 67.7814C6.63994 68.6336 6.73564 69.7694 6.33411 70.901L8.21897 71.5698C8.78987 69.9609 8.70877 68.1794 7.81879 66.7332L6.11548 67.7814ZM6.31848 70.9488L3.35701 80.8499L5.27314 81.423L8.2346 71.522L6.31848 70.9488ZM3.35156 80.8688C2.92533 82.4032 3.35726 83.8355 4.35554 84.7558C5.3426 85.6657 6.79267 85.992 8.2389 85.5382L7.64022 83.63C6.8322 83.8834 6.13852 83.6793 5.71114 83.2853C5.29499 82.9016 5.0418 82.2565 5.27859 81.4041L3.35156 80.8688ZM8.22429 85.5427L17.1529 82.8906L16.5834 80.9734L7.65482 83.6255L8.22429 85.5427ZM17.1792 82.8824C19.1295 82.2442 20.6559 82.9927 22.9399 84.3782L23.9772 82.6683C21.7438 81.3134 19.4689 80.0287 16.5571 80.9816L17.1792 82.8824ZM22.951 84.3849C29.5738 88.286 37.7926 90.2694 45.201 90.2694V88.2694C38.1115 88.2694 30.25 86.3631 23.9661 82.6616L22.951 84.3849ZM45.201 90.2694C67.5964 90.2694 90.402 72.97 90.402 45.0684H88.402C88.402 71.7108 66.653 88.2694 45.201 88.2694V90.2694ZM90.402 45.0684C90.402 21.0235 70.9699 0 45.2894 0V2C69.8212 2 88.402 22.0834 88.402 45.0684H90.402Z",
    fill: "url(#paint1_linear_1_53)",
    mask: "url(#path-3-outside-1_1_53)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_1_53)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_1_53",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1146 50.9024C41.9763 50.8582 39.4568 48.3388 39.4568 45.2005C39.4568 42.1064 42.0205 39.5428 45.1146 39.587C48.2528 39.587 50.7723 42.1064 50.7723 45.2447C50.7723 48.3388 48.2528 50.9024 45.1146 50.9024ZM24.7363 50.9025C21.6422 50.9025 19.0786 48.3389 19.0786 45.2448C19.0786 42.1065 21.598 39.5871 24.7363 39.5871C27.8746 39.5871 30.394 42.1065 30.394 45.2448C30.394 48.3389 27.8746 50.8583 24.7363 50.9025ZM59.8328 45.2447C59.8328 48.3388 62.3523 50.9024 65.4906 50.9024C68.6288 50.9024 71.1483 48.3388 71.1483 45.2447C71.1483 42.1064 68.6288 39.587 65.4906 39.587C62.3523 39.587 59.8328 42.1064 59.8328 45.2447Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1146 50.9024C41.9763 50.8582 39.4568 48.3388 39.4568 45.2005C39.4568 42.1064 42.0205 39.5428 45.1146 39.587C48.2528 39.587 50.7723 42.1064 50.7723 45.2447C50.7723 48.3388 48.2528 50.9024 45.1146 50.9024ZM24.7363 50.9025C21.6422 50.9025 19.0786 48.3389 19.0786 45.2448C19.0786 42.1065 21.598 39.5871 24.7363 39.5871C27.8746 39.5871 30.394 42.1065 30.394 45.2448C30.394 48.3389 27.8746 50.8583 24.7363 50.9025ZM59.8328 45.2447C59.8328 48.3388 62.3523 50.9024 65.4906 50.9024C68.6288 50.9024 71.1483 48.3388 71.1483 45.2447C71.1483 42.1064 68.6288 39.587 65.4906 39.587C62.3523 39.587 59.8328 42.1064 59.8328 45.2447Z",
    fill: "url(#paint2_linear_1_53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1146 50.9024L45.1089 51.3024H45.1146V50.9024ZM45.1146 39.587L45.1089 39.987H45.1146V39.587ZM24.7363 50.9025V51.3026L24.7419 51.3025L24.7363 50.9025ZM39.0568 45.2005C39.0568 48.5607 41.7552 51.2552 45.1089 51.3024L45.1202 50.5025C42.1974 50.4613 39.8568 48.1168 39.8568 45.2005H39.0568ZM45.1203 39.187C41.7997 39.1396 39.0568 41.8867 39.0568 45.2005H39.8568C39.8568 42.3262 42.2413 39.946 45.1089 39.9869L45.1203 39.187ZM51.1723 45.2447C51.1723 41.8855 48.4738 39.187 45.1146 39.187V39.987C48.0319 39.987 50.3723 42.3274 50.3723 45.2447H51.1723ZM45.1146 51.3024C48.4758 51.3024 51.1723 48.5577 51.1723 45.2447H50.3723C50.3723 48.1199 48.0299 50.5024 45.1146 50.5024V51.3024ZM18.6786 45.2448C18.6786 48.5598 21.4213 51.3025 24.7363 51.3025V50.5025C21.8632 50.5025 19.4786 48.118 19.4786 45.2448H18.6786ZM24.7363 39.1871C21.3771 39.1871 18.6786 41.8856 18.6786 45.2448H19.4786C19.4786 42.3275 21.819 39.9871 24.7363 39.9871V39.1871ZM30.794 45.2448C30.794 41.8856 28.0955 39.1871 24.7363 39.1871V39.9871C27.6537 39.9871 29.994 42.3275 29.994 45.2448H30.794ZM24.7419 51.3025C28.0936 51.2553 30.794 48.5629 30.794 45.2448H29.994C29.994 48.1149 27.6555 50.4614 24.7307 50.5026L24.7419 51.3025ZM65.4906 50.5024C62.5752 50.5024 60.2328 48.1199 60.2328 45.2447H59.4328C59.4328 48.5576 62.1294 51.3024 65.4906 51.3024V50.5024ZM70.7483 45.2447C70.7483 48.1199 68.4059 50.5024 65.4906 50.5024V51.3024C68.8518 51.3024 71.5483 48.5576 71.5483 45.2447H70.7483ZM65.4906 39.987C68.4079 39.987 70.7483 42.3273 70.7483 45.2447H71.5483C71.5483 41.8855 68.8498 39.187 65.4906 39.187V39.987ZM60.2328 45.2447C60.2328 42.3273 62.5732 39.987 65.4906 39.987V39.187C62.1314 39.187 59.4328 41.8855 59.4328 45.2447H60.2328Z",
    fill: "url(#paint3_linear_1_53)",
    mask: "url(#path-5-inside-2_1_53)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_53",
    x: 31.668,
    y: 23.6752,
    width: 78.7422,
    height: 78.7423,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_1_53"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1_53",
    x: -24,
    y: -24,
    width: 138.402,
    height: 138.269,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_1_53",
    x: 4.07858,
    y: 24.5864,
    width: 82.0697,
    height: 41.3162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_53"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.170833 0 0 0 0 0.5025 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1_53",
    result: "effect2_dropShadow_1_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_53",
    x1: 71.3608,
    y1: 28.0619,
    x2: 71.3608,
    y2: 97.2363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3685FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_53",
    x1: 15.0722,
    y1: 11.2835,
    x2: 71.3608,
    y2: 81.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_53",
    x1: 67.4565,
    y1: 41.6299,
    x2: 10.6723,
    y2: 50.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_53",
    x1: 27.3672,
    y1: 40.9048,
    x2: 29.8812,
    y2: 55.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.00a5e1d537450a9d82b3637ac6247f37.svg";
export { ForwardRef as ReactComponent };